import * as R from 'ramda'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  upcoming: {
    backgroundColor: theme.palette.warning.main,
  },
  happening: {
    backgroundColor: theme.palette.active.main,
  },
  ended: {
    backgroundColor: theme.palette.map.main,
  },
  canceled: {
    backgroundColor: theme.palette.event.eventCanceled,
  },
}))

export const notificationEventStatus = {
  normal: { status: 1, name: 'normal' },
  upcoming: { status: 2, name: 'upcoming' },
  happening: { status: 3, name: 'happening' },
  ended: { status: 4, name: 'ended' },
  canceled: { status: 5, name: 'canceled' },
}

const eventStatus = [
  {
    status: notificationEventStatus.normal.status,
    name: notificationEventStatus.normal.name,
    labelId: 'notification.eventStatus.normal',
  },
  {
    status: notificationEventStatus.upcoming.status,
    name: notificationEventStatus.upcoming.name,
    labelId: 'notification.eventStatus.upcoming',
  },
  {
    status: notificationEventStatus.happening.status,
    name: notificationEventStatus.happening.name,
    labelId: 'notification.eventStatus.happening',
  },
  {
    status: notificationEventStatus.ended.status,
    name: notificationEventStatus.ended.name,
    labelId: 'notification.eventStatus.ended',
  },
  {
    status: notificationEventStatus.canceled.status,
    name: notificationEventStatus.canceled.name,
    labelId: 'notification.eventStatus.canceled',
  },
]

export const eventStatusFromAPI = (input) => {
  return R.compose(
    R.prop('name'),
    R.find(R.propEq('status', input)),
  )(eventStatus)
}

export const useNotificationEventStatus = (status) => {
  const classes = useStyles()
  const isShowStatus = R.includes(status, [
    notificationEventStatus.upcoming.status,
    notificationEventStatus.happening.status,
    notificationEventStatus.ended.status,
    notificationEventStatus.canceled.status,
  ])

  const statusData = R.find(R.propEq('status', status))(eventStatus)
  const eventStatusLabelId = isShowStatus ? statusData.labelId : null
  const classColorStatus = isShowStatus ? classes[statusData.name] : null

  return [{ eventStatusLabelId, classColorStatus, isShowStatus }]
}
